import { Button, Menu, MenuItem } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { RATE_PLANS } from "../../Utils/CONST";
import { getActiveHotelId } from "../../Utils/Utils";

const AvailibilityToday = ({ inventoryData, currency, allRatePlans }) => {
  const hotelId = getActiveHotelId();

  const [showAll, setShowAll] = useState(false);
  const [selectedRatePlan, setSelectedRatePlan] = useState(
    JSON.parse(
      localStorage.getItem(`sf-${hotelId}-displayRatePlan`) ??
        JSON.stringify({ name: "Base Price", id: -1 })
    )
  );
  const [ratePlanAnchorEl, setRatePlanAnchorEl] = useState(null);
  const { t } = useTranslation();

  const calculateTotalRoomsCount = useCallback((inventoryData) => {
    let total = 0;
    const data = inventoryData?.allRoomTypes?.map(
      (room) =>
        (total =
          total +
          Number(room?.availableRoomCount[0]?.count) +
          Number(room?.offlineRoomCount[0]?.count))
    );
    return total;
  }, []);

  const getMinimumprice = (room) => {
    let minPrice = Infinity;

    (room?.ratePlans || []).forEach((item) => {
      const occupancyPricing = item?.rateInfoMap?.[0]?.occupancyPricing;
      if (occupancyPricing) {
        const minValue = Math.min(...Object.values(occupancyPricing));
        minPrice = Math.min(minPrice, minValue);
      }
    });

    return minPrice === Infinity ? 0 : minPrice;
  };

  const totalRoomsCount = useMemo(
    () => calculateTotalRoomsCount(inventoryData),
    [inventoryData, calculateTotalRoomsCount]
  );

  const toggleShowMore = () => {
    setShowAll((sa) => !sa);
  };

  const generateGroupedData = (ratePlan) => {
    let result = [];

    if (ratePlan?.name === "Base Price") {
      result = inventoryData?.allRoomTypes?.map((room) => {
        let price;

        const standardPlan = room?.ratePlans?.find(
          (rp) => rp?.ratePlanName?.toLowerCase() === "standard plan"
        );

        if (standardPlan) {
          price = standardPlan?.rateInfoMap?.[0]?.occupancyPricing?.["1"];
        } else {
          price = getMinimumprice(room);
        }

        return {
          type: room?.roomTypeName,
          inventory:
            (+room?.availableRoomCount?.[0]?.count || 0) +
            (+room?.offlineRoomCount?.[0]?.count || 0),
          price,
        };
      });
    } else {
      for (const room of inventoryData?.allRoomTypes ?? []) {
        for (const plan of room?.ratePlans ?? []) {
          if (plan?.ratePlanId !== ratePlan?.id) continue;

          const op = plan?.rateInfoMap?.[0]?.occupancyPricing;
          if (op && op["1"]) {
            const data = {};
            data["type"] = room?.roomTypeName;
            data["inventory"] =
              +room?.availableRoomCount[0]?.count +
              +room?.offlineRoomCount[0]?.count;

            data["price"] = op["1"];
            result.push(data);
          }
        }
      }
    }

    return result;
  };

  const groupedData = generateGroupedData(selectedRatePlan);
  const sortedGroupedData = groupedData?.sort((a, b) => a.price - b.price);

  const handleRatePlanSelection = (rp) => {
    localStorage.setItem(`sf-${hotelId}-displayRatePlan`, JSON.stringify(rp));
    setSelectedRatePlan(rp);
    setRatePlanAnchorEl(null);
  };

  return (
    <>
      <div
        style={{
          color: "black",
          fontWeight: "500",
          fontSize: "18px",
          marginLeft: "1rem",
        }}
      >
        {`${t("Availability Today")}`}
      </div>
      <div className="w-100 mt-2">
        <div className="d-flex justify-content-between  w-100">
          <p
            className="font-weight-bold"
            style={{
              color: "gray",
              width: "50%",
              textAlign: "start",
            }}
          >
            {`${t("Room category")}`}
          </p>
          <p
            className="font-weight-bold"
            style={{
              color: "gray",
              width: "25%",
              textAlign: "center",
            }}
          >
            {`${t("Inventory")}`}
          </p>
          <p
            className="font-weight-bold"
            style={{
              color: "gray",
              width: "25%",
              textAlign: "end",
              textDecoration: "underline",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            onClick={(e) => setRatePlanAnchorEl(e.currentTarget)}
          >
            {`${t(selectedRatePlan?.name)}`}
          </p>
        </div>

        {(showAll ? sortedGroupedData : sortedGroupedData?.slice(0, 5))?.map(
          (data, idx) => (
            <div className="d-flex justify-content-between  w-100" key={idx}>
              <p
                className="font-weight-bold"
                style={{
                  color: "gray",
                  width: "60%",
                  textAlign: "start",
                }}
              >
                {data.type}
              </p>
              <p
                className="font-weight-bold"
                style={{
                  color: "gray",
                  width: "10%",
                  textAlign: "center",
                }}
              >
                {data.inventory}
              </p>
              <p
                className="font-weight-bold"
                style={{
                  color: "gray",
                  width: "30%",
                  textAlign: "end",
                }}
              >
                {`${currency} ${data.price}`}
              </p>
            </div>
          )
        )}

        {/* TOTAL ROOM COUNT  */}
        {(showAll || (sortedGroupedData?.length || 0) <= 4) && (
          <div className="d-flex justify-content-between ">
            <p
              style={{
                color: "gray",
                width: "62%",
                textAlign: "start",
                fontWeight: "bold",
              }}
            >
              {`${t("Total Available Rooms")}`}
            </p>
            <p
              className="font-weight-bold"
              style={{
                color: "gray",
                width: "10%",
                textAlign: "start",
                fontWeight: "bold",
              }}
            >
              {totalRoomsCount}
            </p>
            <p
              className="font-weight-bold"
              style={{
                color: "gray",
                width: "25%",
                textAlign: "end",
              }}
            ></p>
          </div>
        )}

        {sortedGroupedData?.length > 5 && (
          <div className="ml-4 mr-4">
            <button
              onClick={toggleShowMore}
              className="btn btn-link"
              style={{
                color: "#1BC5BD",
                textDecoration: "underline",
                fontWeight: "bold",
              }}
            >
              {showAll ? `${t("Show less")}` : `${t("Show More")}`}
            </button>
          </div>
        )}
      </div>

      {/* RATE PLANS MENU  */}
      {!!ratePlanAnchorEl && (
        <Menu
          anchorEl={ratePlanAnchorEl}
          open={!!ratePlanAnchorEl}
          onClose={() => setRatePlanAnchorEl(null)}
          slotProps={{
            list: {
              "aria-labelledby": "basic-button",
            },
          }}
        >
          {[
            { name: "Base Price" },
            ...allRatePlans?.filter((rp) => rp?.rate_plan_status === "ENABLED"),
          ]?.map((rp) => {
            return (
              <MenuItem onClick={() => handleRatePlanSelection(rp)}>
                {rp?.name}
              </MenuItem>
            );
          })}
        </Menu>
      )}
    </>
  );
};

export default AvailibilityToday;
